import script from "./MapElemInfoJunkaiTenkenReportTenkenData.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapElemInfoJunkaiTenkenReportTenkenData.vue?vue&type=script&setup=true&lang=ts"

import "./MapElemInfoJunkaiTenkenReportTenkenData.vue?vue&type=style&index=0&id=fffad624&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fffad624"]])

export default __exports__